import { postAirUpdateBalance } from '../api/postAirUpdateBalance';
import {setGetUserById} from './setGetUserById';

const setPostAirUpdateBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            await postAirUpdateBalance(params);
            dispatch(setGetUserById(params.user_id));
            window.location.replace(window.location.pathname);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostAirUpdateBalance
}